module.exports = __webpack_public_path__ + "img/medal1.1c7878a7.svg";